import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { CloseIcon } from "@icarius-icons";
import {
    DialogContent,
    DialogActions,
    DialogTitle,
    Dialog,
    TextField,
    Grid
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import PaperDraggable from "@icarius-common/paperDraggable";
import CustomNumberFormat from '@icarius-common/dynamicInputs/customNumberFormat';

const QuestionFormDialog = (props) => {
    const { open, handleClose, handleSave, initialData, questions, editIndex } = props;
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({ order: "", question: "" });

    useEffect(() => {
        if (open) {
            setFormData(initialData || { order: "", question: "" });
        }
    }, [open, initialData]);

    const onChange = (e, field) => {
        setFormData({
            ...formData,
            [field]: e.target.value
        });
    };

    const isAcceptDisabled = !formData.order || !formData.question;

    const onAccept = () => {
        const parsedOrder = Number(formData.order);
        const orderExists = questions?.some((q, index) => Number(q.order) === parsedOrder && index !== editIndex);

        if (orderExists) {
            dispatch(openSnackbarAction({
                msg: getLocalizedString("orderAlreadyInUse"),
                severity: "error"
            }));
            return;
        }

        handleSave(formData);
    };

    const title = initialData ? getLocalizedString("editQuestion") : getLocalizedString("addQuestion");

    return (
        <Dialog
            TransitionComponent={DialogTransition}
            PaperComponent={PaperDraggable}
            open={open}
            scroll={"paper"}
            maxWidth={"sm"}
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {title}
                <DialogTitleDivider />
            </DialogTitle>
            <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
            <DialogContent style={{ paddingTop: 10 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            required
                            fullWidth
                            label={getLocalizedString("order")}
                            InputProps={{ inputComponent: CustomNumberFormat }}
                            value={formData.order}
                            onChange={(e) => onChange(e, "order")}
                            margin="dense"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            fullWidth
                            label={getLocalizedString("question")}
                            value={formData.question}
                            onChange={(e) => onChange(e, "question")}
                            margin="dense"
                            multiline
                            rows={3}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
                <ButtonDialogAction disabled={isAcceptDisabled} onClick={onAccept} isAccept text={getLocalizedString("accept")} />
            </DialogActions>
        </Dialog>
    );
};

export default QuestionFormDialog;
